import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Importă Navbar-ul aici!


import Acasa from "./pages/Acasa";
import Preturi from "./pages/Preturi";
import Servicii from "./pages/Servicii";
import Contact from "./pages/Contact";
import Bucuresti from "./pages/Bucuresti-sector-2";

// servicii
import Autoturisme from "./servicii/itp-autoturisme"
import Motociclete from "./servicii/itp-motociclete-atv"
import Scanare from "./servicii/scanare-computerizata"
import Utilitare from "./servicii/itp-vehicule-utilitare"

import FloatingButtons from "./butoane/FloatingButtons";

function App() {
  return (
    <Router>
      {/* 💡 NAVBAR-UL TREBUIE SĂ FIE AICI, ÎN AFARA <ROUTES> */}

      <Routes>
        <Route path="/" element={<Acasa />} />
        <Route path="/preturi" element={<Preturi />} />
        <Route path="/servicii" element={<Servicii />} />
        
        <Route path="/servicii/itp-autoturisme" element={<Autoturisme />} />
        <Route path="/servicii/itp-motociclete-atv" element={<Motociclete />} />
        <Route path="/servicii/scanare-computerizata" element={<Scanare />} />
        <Route path="/servicii/itp-vehicule-utilitare" element={<Utilitare />} />
        
        <Route path="/contact" element={<Contact />} />
        <Route path="/bucuresti-sector2" element={<Bucuresti />} />
      </Routes>

      <FloatingButtons />
    </Router>
  );
}

export default App;